import type { RichContentRunnerDetails } from '@ps/web-sports-api-types';
import React from 'react';

import styles from './JockeyAndTrainerDetails.scss';

interface Props {
  details: RichContentRunnerDetails | undefined;
}

const JockeyAndTrainerDetails: React.FC<Props> = ({ details }) => {
  const jockeyName = details?.jockeyName;
  const trainerName = details?.trainerName;

  const shouldDisplayJockeyAndTrainer = jockeyName || trainerName;

  if (!shouldDisplayJockeyAndTrainer) return null;

  return (
    <div className={styles.extraRunnerInformation}>
      <span>{`J: ${jockeyName || '-'}`}</span>
      <span>{`T: ${trainerName || '-'}`}</span>
    </div>
  );
};

export default JockeyAndTrainerDetails;
